import { createFileRoute, useRouteContext } from '@tanstack/react-router';
import { ApiKeysManager } from '@/components/api-keys/api-keys-manager';
import { OAuthClientsManager } from '@/components/oauth-clients/oauth-clients-manager';
import { PageContent } from '@/components/page-content';
import { Card, CardContent } from '@/components/ui/card';
import { hasPermission } from '@/lib/permissions';

export const Route = createFileRoute(
  '/_auth/_side-layout/integrations/access/api',
)({
  component: ApiAccessPage,
});

function ApiAccessPage() {
  const { userRole } = useRouteContext({ from: '/_auth' });

  return (
    <PageContent>
      {hasPermission(userRole, { organization: ['update'] }) ? (
        <>
          <ApiKeysManager />
          <OAuthClientsManager />
        </>
      ) : (
        <Card>
          <CardContent>
            <p className="text-muted-foreground text-sm">
              Only owners and admins can manage API keys and OAuth clients. Ask
              an admin if your integration needs REST API access.
            </p>
          </CardContent>
        </Card>
      )}
    </PageContent>
  );
}
